/* show full thumb in video container on lightbox items hover */
(function ($) {

    var $item = $('.js-m-lightbox-show-full');
    var $container = $('.m-lightbox-on-hover');
    if (!$item.length || !$container.length) return false;

    var timer;

    // only for desktop
    if ($(window).width() > 1200) {
        $item
            .on('mouseenter', function () {
                clearTimeout(timer);
                $container.css('background-image', 'url(' + $(this).attr('href') +')');
                $container.removeClass('is-disabled');
            })
            .on('mouseleave', function () {
                timer = setTimeout(function () {
                    $container.addClass('is-disabled');
                    $container.css('background-image', '');
                }, 100);
            });
    }

})(jQuery);